// extracted by mini-css-extract-plugin
export default {"titleWrap":"searchTitle_titleWrap__piHbn","title":"searchTitle_title__qpRZ5","subTitle":"searchTitle_subTitle__81szE"};